<template>
    
    <v-card class="message-card" dense dark>
      
      <v-card-text class="subtitle" style="color: black">
        {{myMessage}}
      </v-card-text>
      
    </v-card>

</template>

<script>

//import axios from 'axios';
//import SnackBar from "../snackbar";


export default {
  props: {
    myMessage : String
  },

  beforeMount () {

    
  },

  data: () => ({
    
    

  }),

  methods : {

    
  }
};
</script>

<style>

.message-card{
  background-color: rgba(255, 255, 255, 0.8) !important;
  border-color:white !important;
}

</style>